import {useCallback} from "react";
import {call} from "redux-saga/effects";

import {useSagaCallback} from "../store/sagas";
import {apiPost} from "./client";

export const useDelete = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (id, type) {
        yield call(apiPost, `/api/v2/action/delete`, {
            id,
            type,
        });
    }, []));
};
